export default function ContactSection() {
  return (
    <section id="contact" className="section-anchor py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="relative z-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">爆料投稿</h2>
              <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
                你手里有料？欢迎匿名投稿。我们承诺严格保护每一位爆料人的隐私安全，让你的声音被听见。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-[700px] mx-auto">
              {[
                { icon: 'ri-mail-send-line', title: '邮箱投稿', desc: '发送至官方爆料邮箱，支持文字、图片、视频等多种格式', action: '点击查看邮箱' },
                { icon: 'ri-wechat-line', title: '微信投稿', desc: '添加官方爆料微信号，一对一私密沟通，全程加密保护', action: '添加微信号' },
                { icon: 'ri-shield-check-line', title: '匿名保障', desc: '所有投稿默认匿名处理，不记录任何个人身份信息', action: '了解详情' },
              ].map((item, i) => (
                <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70 text-center cursor-pointer hover:border-primary-200/50 transition-colors">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-500 text-3xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
                  <span className="inline-block text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
                    {item.action} <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}